export default __webpack_public_path__ + "static/media/buildings_park.eeb69cd0.jpg";